<template>
  <v-card>
    <v-container fill-height fluid class="pa-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar flat class="secondary--text" style="background: transparent">
            <v-toolbar-title>
              Novas versões foram encontradas
            </v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panel v-if="versoes">
            <v-expansion-panel-content
              v-for="(versao, index) in versoes"
              :key="index"
            >
              <template v-slot:header>
                Versão: {{versao.versao}}
                <v-spacer></v-spacer>
                Data da versão: {{versao.data_versao.split('-').reverse().join('-')}}
              </template>
              <v-divider></v-divider>
              <v-card>
                <v-card-title class="grey--text text--darken-2">
                  <h4>Atualizações:</h4>
                </v-card-title>
                <v-card-text>
                  {{versao.descricao}}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    versoes () {
      return this.$store.getters.versoes
    }
  }
}
</script>
